import { Inject, Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from "@angular/router";
import { Observable } from "rxjs";
import { AuthService } from "../services/auth.service";

@Injectable({
  providedIn: "root",
})
export class AuthGuard implements CanActivate {
  constructor(
    @Inject(AuthService) private authService: AuthService,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return new Promise(async (resolve) => {
      this.authService.getAuth().onAuthStateChanged(async (user) => {
        if (!user) {
          this.router.navigate(["login"]);
          resolve(false);
          return;
        }

        const isAdmin = await this.authService.ensureAdminAccess();
        if (!isAdmin) {
          this.router.navigate(["login"]);
          resolve(false);
          return;
        }

        resolve(true);
      });
    });
  }
}
